import { useParams } from "react-router-dom";
import { ScopeType, useScope } from "~/hooks/useScope";
import { AdvisoryContentDetails } from "~/components/vulnerabilities";
import { useFindingOnAsset } from "~/pages/findings/FindingOnAsset/hooks";
import { isAdvisoryOrCveFinding } from "~/pages/findings/FindingOnAsset/utils";
import { CveRelatedAdvisoryFindings } from "./CveRelatedAdvisoryFindings";

export function RelatedFindings() {
  const { activeScope, spaceScope } = useScope();
  const { vulnId = "", advisoryId = "" } = useParams();
  const { finding } = useFindingOnAsset();

  const noSpaceAndSpace = !spaceScope || !activeScope;

  if (noSpaceAndSpace) {
    // This should never happen, but if it does, we don't want to render anything.
    return null;
  }

  const isWorkspace = activeScope.type === ScopeType.Workspace;
  const isSpace = activeScope.type === ScopeType.Space;

  if ((!isWorkspace && !isSpace) || !isAdvisoryOrCveFinding(finding)) {
    // We only want to render this component for workspace or space scopes.
    return null;
  }

  return vulnId ? (
    <CveRelatedAdvisoryFindings finding={finding} />
  ) : (
    <AdvisoryContentDetails advisoryId={advisoryId} scope={activeScope} />
  );
}
